import {Component, Inject, OnInit} from '@angular/core';
import {ProgressBarMode} from '@angular/material/progress-bar';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {IcDataUserService} from '../../services/ic-data.user.service';
import {NICEUserSkill} from '../../models/NICE_UserSkill.model';
import {map} from 'rxjs/operators';
import {GeneralService} from '../../services/general.service';
import {AuthService} from '../../services/auth.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {IcDataTeamService} from '../../services/ic-data.team.service';

@Component({
    selector: 'app-update-record-dialog',
    templateUrl: './update-record-dialog.component.html',
    styleUrls: ['./update-record-dialog.component.scss']
})
export class UpdateRecordDialogComponent implements OnInit {
    showProgress = false;
    progressMode: ProgressBarMode = 'determinate';
    completeProgress = 0;
    currentProcessIndex = 0;
    totalProcessCount = 0;
    processingRecord: string;
    processRecords: any[] = [];
    recordType: string;
    updateData: any;
    statusMessage: string;
    complete = '';

    constructor(
        private dialogRef: MatDialogRef<UpdateRecordDialogComponent>,
        public _icDataUser: IcDataUserService,
        public _icDataTeam: IcDataTeamService,
        public genHttp: GeneralService,
        public auth: AuthService,
        private _matSnackBar: MatSnackBar,
        @Inject(MAT_DIALOG_DATA) public data: UpdateRecordModel,
    ) {
    }

    ngOnInit(): void {
        this.processRecords = this.data.updateList;
        this.recordType = this.data.recordType;
        this.updateData = this.data.updateData;
        this.totalProcessCount = this.processRecords.length;
        if (this.recordType === 'User_Skills') {
            // handles updating of User skills based on a give user's skills
            this.processUserSkill().then((processResult) => {
                    this.dialogRef.close(processResult);
            });
        }
        if (this.recordType === 'Team_Outstate') {
            // handles updating of Outstates for teams based on a given teams outstates
            this.processTeamOutState().then((processResult) => {
                if (processResult) {
                    this.dialogRef.close(true);
                }
            });
        }

    }

    async processUserSkill(): Promise<any> {
        this.showProgress = true;
        this.progressMode = 'determinate';
        let createSuccess = true;
        for (let idx = 0; idx < this.totalProcessCount; idx++) {
            const record = this.processRecords[idx];
            this.processingRecord = record.fullName;
            this.currentProcessIndex = idx;
            this.completeProgress = Math.round((idx + 1) * 100 / this.totalProcessCount);
            try {
                if (record.copyAssignments) {
                    createSuccess = false;
                    const targetUserSkill = await this.getAgentSkill(record.agentId);
                    await this._icDataUser.updateUsersWithSkill(targetUserSkill, record.copyAssignments, record.agentId);
                    createSuccess = true;
                }
                if (record.copyUserDetails) {
                    createSuccess = false;
                    await this._icDataUser.updateUserById(record.agentId, record.copyUserDetails);
                    createSuccess = true;
                }
                this._matSnackBar.open('Users Updated!', 'OK', {
                    verticalPosition: 'top',
                    duration: 5000
                });
            }
            catch(error){
                const errorMessage = error.error.error_description;
                this._matSnackBar.open(errorMessage, 'OK', {
                    verticalPosition: 'top',
                    duration: 5000
                });
                return false
            }
        }

        return createSuccess;
    }

    async getAgentSkill(agentId: string): Promise<NICEUserSkill[]> {
        return new Promise((resolve, reject) => {
            this.genHttp.icGet('baseURL/services/' + this.auth.apiVersion + '/agents/' + agentId + '/skills')
                .pipe(map((response: any) => {
                    if (response === null) {
                        return [];
                    }
                    return response.agentSkillAssignments.map(data => new NICEUserSkill(data));
                }))
                .subscribe((response: NICEUserSkill[]) => {
                    resolve(response);
                }, reject);
        });
    }

    async processTeamOutState(): Promise<any> {
        this.showProgress = true;
        this.progressMode = 'determinate';
        for (let idx = 0; idx < this.totalProcessCount; idx++) {
            const record = this.processRecords[idx];
            this.processingRecord = record.teamnName;
            this.currentProcessIndex = idx;
            this.completeProgress = Math.round((idx + 1) * 100 / this.totalProcessCount);
            let createSuccess = false;
            await this._icDataTeam.updateTeamOutStates(record.teamId, this.updateData).then(() => {
                createSuccess = true;
            })
                .catch((error) => {
                    this.dialogRef.close(error);
                });
            if (!createSuccess) {
                return false;
            }
        }
        this._matSnackBar.open('Teams Updated!', 'OK', {
            verticalPosition: 'top',
            duration: 5000
        });
        return true;
    }
}
export class UpdateRecordModel {
    constructor(
        public updateList: any[] = [],
        public updateData: any[] = [],
        public recordType: string,
    ) {

    }
}
